<template>
    <time :datetime="datetime">{{ date }}</time>
</template>

<script setup>
import useGlobalStore from '~/stores/GlobalStore'

const props = defineProps({
    format: {
        type: String,
        default: 'Digit',
    },
})

// Importing the global state for the date
const globalStore = useGlobalStore()

const date = computed(() => {
    // Grab the date (adjusted to the user's timezone)
    const userDate = globalStore.userDate
    // Get the day (will be prepended by 0 if the result is just 1 digit)
    const day = String(userDate.getDate()).padStart(2, '0')
    // Get the month + 1 because it returns Jan as 0 (will be prepended by 0 if the result is just 1 digit)
    const month = String(userDate.getMonth() + 1).padStart(2, '0')
    // Get the year
    const year = userDate.getFullYear()
    // Display the result based on the provided format
    if (props.format === 'Digit') {
        // Now let's check whether we display the date as Standard vs. American
        if (globalStore.celsiusUnit === true) {
            return `${day}-${month}-${year}`
        } else {
            return `${month}-${day}-${year}`
        }
    } else if (props.format === 'Text') {
        const monthText = userDate.toLocaleString('en-EN', {
            month: 'long',
        })
        // Now let's check whether we display the date as Standard vs. American
        if (globalStore.celsiusUnit === true) {
            return `${day} ${monthText}, ${year}`
        } else {
            return `${monthText} ${day}, ${year}`
        }
    }

    return ''
})

const datetime = computed(() => {
    return globalStore.userDate.toISOString()
})
</script>
